var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 -1 14 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16447 8.8501H8.77144V10.3598H1.16447C0.747588 10.3598 0.409607 10.0219 0.409607 9.60499C0.409607 9.18811 0.747588 8.8501 1.16447 8.8501Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16447 5.82071H8.77144V7.33046H1.16447C0.747588 7.33046 0.409607 6.99248 0.409607 6.57557C0.409607 6.15866 0.747588 5.82071 1.16447 5.82071Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16447 4.30106V4.30103C0.747588 4.30103 0.409607 3.96307 0.409607 3.54617C0.409607 3.12926 0.747588 2.79131 1.16447 2.79131H6.44923C6.38953 2.97515 6.35801 3.16907 6.35801 3.36799C6.35801 3.7011 6.44536 4.02062 6.6085 4.30106H1.16447Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7204 4.04299C13.3476 4.4158 12.7432 4.4158 12.3704 4.04299L11.5866 3.25919V11.4184C11.5866 11.9456 11.1592 12.373 10.6319 12.373C10.1047 12.373 9.6773 11.9456 9.6773 11.4184V3.25919L8.8935 4.04299C8.52069 4.41577 7.91627 4.4158 7.54346 4.04299C7.17065 3.67019 7.17065 3.06577 7.54346 2.69296L9.95677 0.27968C10.3288 -0.0925064 10.934 -0.0937767 11.3071 0.27968L13.7204 2.69296C14.0932 3.06577 14.0932 3.67019 13.7204 4.04299Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.b2be9b5609063a9b7c435ccf41c7ff42.svg";
export { ForwardRef as ReactComponent };